<template>
  <div>    
    <div class="row">
      <div class="col-lg-12 col-md-12 box-release">
        <p>{{ $t("292") }}</p>

        <br/>
          <input type="radio" id="en" value="en" v-model="lang"> <img src="static/flags/US.png"/> <label for="one">{{ $t("293") }}</label>
          <br/>
          <input type="radio" id="pt" value="pt" v-model="lang"> <img src="static/flags/BR.png"/> <label for="two">{{ $t("294") }}</label>
          <br/><br/>

         <!--  <span>Escolhido: {{ lang }}</span> -->
          <br/>
          <br/>

        <button type="button" class="btn btn-sm botao-save" @click="saveLang()" >{{ $t("295") }}</button>
       
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueTabs from 'vue-nav-tabs'
  Vue.use(VueTabs)

  export default {
    data () {
      return {
        lang: 'en'
      }
    },
    mounted () {
      const lang = localStorage.getItem('lang')
      this.lang = !lang ? 'en' : lang
    },
    methods: {
      saveLang () {
        var lang = this.lang
        this.$store.dispatch('setLang', lang)
      },
    }  
  }
</script>
<style>
.box-release{
  margin: 70px auto 0px auto;
  height: 600px;
  text-align: center;

}

.botao-save{
  width: 28%!important;
  border: none!important;
  color: #ccc!important;
  padding: 10px 10px!important;
  background-color: #134f69!important;
  font-size: 15px!important;
}

.botao-save:hover{
  background-color: #042d3f!important;
}

.botao-save a{
  color: #ccc!important;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Language.vue